/*
 * SiteFooter — gold hairline, wordmark, section index, tagline.
 */
import { Link } from "wouter";
import { sections } from "@/content/sections";
import ResponsiveImage from "@/components/ResponsiveImage";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border mt-24">
      <div className="container py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <ResponsiveImage
                src="/manus-storage/logo-mark_a78a62da.png"
                alt="According to Porsha monogram"
                sizes="48px"
                className="h-12 w-12"
              />
              <div>
                <p
                  className="text-[0.6rem] font-semibold uppercase"
                  style={{ letterSpacing: "0.34em", color: "var(--gold)" }}
                >
                  According to
                </p>
                <p className="font-script text-4xl" style={{ color: "var(--violet)" }}>
                  Porsha
                </p>
              </div>
            </div>
            <p className="mt-5 text-sm text-muted-foreground max-w-sm leading-relaxed">
              A premium editorial publication covering culture, style, city life,
              and the conversations that matter.
            </p>
            <p className="kicker mt-6">Real. Raw. Relevant.</p>
          </div>
          <div className="md:col-span-4">
            <p className="kicker mb-5">Sections</p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              {sections.map((s) => (
                <Link
                  key={s.slug}
                  href={`/${s.slug}`}
                  className="text-sm text-foreground/75 hover:text-[var(--gold-2)] transition-colors"
                >
                  {s.name}
                </Link>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="kicker mb-5">The Publication</p>
            <div className="flex flex-col gap-3">
              <Link href="/about" className="text-sm text-foreground/75 hover:text-[var(--gold-2)] transition-colors">About Porsha</Link>
              <Link href="/subscribe" className="text-sm text-foreground/75 hover:text-[var(--gold-2)] transition-colors">The Monthly Edit</Link>
              <Link href="/advertise" className="text-sm text-foreground/75 hover:text-[var(--gold-2)] transition-colors">Advertise / Partner</Link>
              <Link href="/contact" className="text-sm text-foreground/75 hover:text-[var(--gold-2)] transition-colors">Contact</Link>
            </div>
          </div>
        </div>
        <div className="gold-rule mt-12 mb-6 opacity-60" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {year} According to Porsha. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground italic font-display">
            "Pour a glass — here's the tea."
          </p>
        </div>
      </div>
    </footer>
  );
}
